const WIX_MEDIA_BASE_URL = "https://static.wixstatic.com/";
const WIX_VIDEO_BASE_URL = "https://video.wixstatic.com/";
export {
  WIX_MEDIA_BASE_URL,
  WIX_VIDEO_BASE_URL
};
//# sourceMappingURL=media-url-consts.js.map
